import { Injectable, Inject } from '@angular/core';
import { Router, Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Pedido } from './pedido.model';
import { BackendService } from '../core/backend.service';
import { OperationalParametric } from '../cliente/operationalParametric.model';
import { EstadoPedido } from './estado-pedido.model';
import { SecurityService } from '../security/security.service';
import { Role } from '../security/role/role.model';

@Injectable()
export class PedidoResolver implements Resolve<Pedido> {
  user: any;
  rol:Role;
  constructor(
    protected router: Router,
    protected backendService: BackendService,
    private authService: SecurityService,
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    try {
      this.user = this.authService.user;
      await this.backendService.get(Role,"/new-roles/user/"+this.user.id).toPromise().then(a =>{
        this.rol = a;
      });
      const id = route.params.id || 'agregar';

      if (id === 'agregar') {
        const pedido = this.backendService.new(Pedido);
        pedido.estado = new OperationalParametric();
        pedido.estado.id = EstadoPedido.Abierto;
        return pedido;
      }
      if(this.rol.name == "SELLER CENTER" || this.rol.id == 3){
        return await this.backendService.get(Pedido, Pedido.path + 'proveedor/' + id).toPromise();
      }

      return await this.backendService.get(Pedido, Pedido.path + id).toPromise();
    } catch (error) {
      console.log(error)
      this.router.navigate(['/pedidos']);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pedido/pedido.resolver.ts